import { render, staticRenderFns } from "./ProfileNavigation.vue?vue&type=template&id=9dec0b00&scoped=true"
import script from "./ProfileNavigation.vue?vue&type=script&lang=ts"
export * from "./ProfileNavigation.vue?vue&type=script&lang=ts"
import style0 from "./ProfileNavigation.vue?vue&type=style&index=0&id=9dec0b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dec0b00",
  null
  
)

export default component.exports